import Consts from "../../consts/clientConsts"
import TradePoint from "../tradePoints/TradePointViewEdit"

export default class {

    Id = null;

    UpdateAt = null;

    Name = null;

    AuditName = null;

    TradePoint = null;

    Status = null;

    Comment = null;

    CompletionDate = null;

    CreationDate = null;

    IsShortCall	= false;
    IsCanFinish = false;
    IsNeedSaveMagnit = false;
    IsMagnitQuestionsAnswered = false;

    QuestionList = [];
    MagnitQuestionList = [];

    CompletionLocation = null;
    CreationLocation = null;

    mapFromDto(formDto) {
        if(!formDto)
            return this;
        
        this.Id = formDto.Id;
        this.UpdateAt = formDto.UpdatedAt;
        this.Name = formDto.Name;
        this.AuditName = formDto.AuditName;

        if(formDto.TradePoint)
            this.TradePoint = new TradePoint(formDto.TradePoint);
            
        this.Status = Consts.AuditStatus.find(e => e.Id == formDto.Status);
        this.Comment = formDto.Comment;
        this.CompletionDate = formDto.CompletionDate;
        this.CreationDate = formDto.CreationDate;

        this.IsShortCall = formDto.IsShortCall;
        this.IsCanFinish = formDto.IsCanFinish;
        this.IsNeedSaveMagnit = formDto.IsNeedSaveMagnit;
        this.IsMagnitQuestionsAnswered = formDto.IsMagnitQuestionsAnswered;

        this.QuestionList = formDto.QuestionList.map(e => new Question().mapFromDto(e));
        this.MagnitQuestionList = formDto.MagnitQuestionList.map(e => new Question().mapFromDto(e));

        this.CompletionLocation = formDto.CompletionLocation;
        this.CreationLocation = formDto.CreationLocation;

        return this;
    }

    isExistsMagnitQuestions() {
        return Boolean(this.MagnitQuestionList.length);
    }
    
    showTask(task) {
        this.TradePoint.showTask(task);
    }
}

class Question {

    Id = null;
    Name = null;
    IsAnswered = null;
    Answer = null;

    ImagePath = null;
    ColorClass = null;
    
    mapFromDto(questionDto) {
        if(!questionDto)
            return this;

        this.Id = questionDto.QuestionId;
        this.Name = questionDto.Name;
        this.IsAnswered = questionDto.IsAnswered;
        this.Answer = questionDto.Answer;
        
        this.ImagePath = this.IsAnswered ? '/img/check-green.png' : '/img/check-empty.png';
        this.ColorClass = this.IsAnswered ? 'green' : '';
        
        return this;
    }
}